/** Who is signed in to a dealership staff portal, with the UX permissions their role grants. */
export class StaffSessionUser {
    id;
    username;
    displayName;
    roles;
    permissions;
    constructor(id, username, displayName, roles, permissions) {
        this.id = id;
        this.username = username;
        this.displayName = displayName;
        this.roles = roles;
        this.permissions = permissions;
    }
    /** Mirrors the legacy portal grants; the API still enforces every call. */
    static permissionsForRole(role) {
        switch (role) {
            case "owner":
            case "manager":
            case "admin":
                return ["*", "admin:access", "listings:write", "content:write", "business:read", "business:write"];
            case "sales":
                return ["listings:write", "business:read"];
            default:
                return [];
        }
    }
    static fromClaims(claims, username) {
        const name = username || claims.sub.slice(0, 8);
        const role = String(claims.role ?? "sales");
        return new StaffSessionUser(claims.sub, name, name, [role], StaffSessionUser.permissionsForRole(role));
    }
    can(permission) {
        return this.permissions.includes("*") || this.permissions.includes(permission);
    }
}
//# sourceMappingURL=StaffSessionUser.js.map